import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { EmployerLayout } from "@/components/employer/portal/EmployerLayout";
import { apiFetch, EmptyState, formatDate, SecondaryButton, Spinner } from "@/components/employer/portal/shared";

export default function EmployerNotifications() {
    const [items, setItems] = useState(null);

    const load = () => apiFetch("/employer/notifications").then((r) => (r.ok ? r.json() : [])).then(setItems);
    useEffect(() => { load(); }, []);

    const read = async (id) => {
        await apiFetch(`/employer/notifications/${id}/read`, { method: "POST" });
        load();
    };

    const readAll = async () => {
        await apiFetch("/employer/notifications/read-all", { method: "POST" });
        load();
    };

    return (
        <EmployerLayout title="Notifications" subtitle="Verification, job review and account updates from Afrinexa." actions={<SecondaryButton data-testid="notifications-read-all" onClick={readAll}>Mark all read</SecondaryButton>}>
            {!items ? <Spinner /> : items.length === 0 ? (
                <EmptyState title="No notifications" copy="Important employer account updates will appear here." />
            ) : (
                <div className="border-t border-ink/10" data-testid="notifications-list">
                    {items.map((item) => (
                        <article key={item.id} data-testid={`notification-${item.id}`} className={`grid gap-4 border-b border-ink/10 px-2 py-5 sm:grid-cols-[auto_1fr_auto] ${item.read ? "opacity-60" : ""}`}>
                            <span className={`mt-1 flex h-9 w-9 items-center justify-center border ${item.read ? "border-ink/15 text-ink/35" : "border-champagne/50 bg-champagne/10 text-[#8a7320]"}`}><Bell size={15} /></span>
                            <div>
                                <h2 className="font-medium text-ink">{item.title}</h2>
                                <p className="mt-1 text-sm leading-relaxed text-ink/60">{item.message}</p>
                                <p className="mt-2 text-xs text-ink/40">{formatDate(item.created_at, true)}</p>
                            </div>
                            {!item.read && <button type="button" data-testid={`notification-read-${item.id}`} onClick={() => read(item.id)} className="h-fit text-xs font-semibold uppercase tracking-[0.14em] text-forest hover:text-champagne">Mark read</button>}
                        </article>
                    ))}
                </div>
            )}
        </EmployerLayout>
    );
}
